import styled from 'styled-components';
import { BreakPoints } from '@makemydeal/dr-ui-bricks-utils';

export const HamburgerButton = styled.button`
    display: none;
    align-items: center;
    justify-content: center;
    background: none;
    border: none;
    padding: 0;
    cursor: pointer;
    color: ${({ theme }) => theme.uiBricks.modalBackgroundColor};

    svg {
        width: 16px;
        height: 16px;
    }

    /* Only shown on tablet widths where the left nav collapses into a drawer */
    @media (max-width: ${BreakPoints.TABLET}) {
        display: inline-flex;
    }
`;
